import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export const getPlayerHighlights = async (playerId) => {
  const { data } = await req(ENDPOINTS.PLAYERS.GET_PLAYER_HIGHLIGHTS(playerId))
  return Array.isArray(data) ? data : []
}

export const getHighlight = async (highlightId) => {
  const { data } = await req(ENDPOINTS.HIGHLIGHTS.GET_HIGHLIGHT(highlightId))
  return data
}
